module.exports = __webpack_public_path__ + "static/media/iconFacebook.10b52d62.svg";